export const box = {
  // <Box variant="box.mobile" />
  mobile: {
    display: ['block', 'none'],
    1: {
      display: ['inline-block', 'none'],
    },
  },
  // <Box variant="box.desktop" />
  desktop: {
    display: ['none', 'block'],
    1: {
      display: ['none', 'inline-block'],
    },
  },
  // <Box variant="box.fill" />
  fill: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
  },
};
